// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Typography} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomModal from '../../../../elements/CustomModal/CustomModal';

import type {OrderState} from '../../../../entities';
import {Error} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';

type Props = {
  isSaving?: boolean,
  open: boolean,
  handleClose: () => void,
  handleUpdateOrderState: (state: OrderState) => void,
};
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(5, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 330,
  },
  icon: {
    color: colors.error,
    fontSize: '3rem',
  },
  title: {
    textAlign: 'center',
    fontSize: '1.25rem',
    fontWeight: 600,
    margin: theme.spacing(1),
  },
  text: {
    textAlign: 'center',
    fontSize: '0.875rem',
    fontWeight: 400,
    marginBottom: theme.spacing(2),
  },
  button: {
    height: 40,
    fontSize: '1rem',
    // fontWeight: 600,
    alignSelf: 'stretch',
  },
}));

export default function CancelModal(props: Props) {
  const {isSaving, open, handleClose, handleUpdateOrderState} = props;
  const classes = useStyles();

  const handleCloseModal = () => {
    if (!isSaving) {
      handleClose();
    }
  };

  const handleSubmit = () => {
    handleUpdateOrderState('CANCELLED');
    handleCloseModal();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Error className={classes.icon} />
        <Typography className={classes.title}>
          ¿Está seguro que desea cancelar el pedido?
        </Typography>
        <Typography className={classes.text}>
          Una vez cancelado el pedido no podrá recuperarse
        </Typography>
        <Divider />
        <CustomButton
          className={classes.button}
          variant="contained"
          onClick={handleSubmit}
        >
          Cancelar Pedido
        </CustomButton>
        <CustomButton className={classes.button} onClick={handleCloseModal}>
          Cerrar
        </CustomButton>
      </div>
    </CustomModal>
  );
}

CancelModal.propTypes = {
  isSaving: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleUpdateOrderState: PropTypes.func.isRequired,
};
